<template>
<div>
  <v-layout >
      <v-flex xs12>
        <div class="white py-4" v-if="!hasProAccess" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly, 'misty' : loadingOnAddItem}">
          <v-layout row wrap pb-3>
            <v-flex grow>
              <span class="subheading">Upgrade your account to connect to your Bank.</span>
              <p>Bank integration is for paid <strong>Premium</strong> plans only.</p>
              <p class="mt-3">With the Premium plan, you can connect Worktabs to your bank account. Not only does this give you a live bank statement from within the app, but Worktabs can suggest which invoices have been paid by bank transfer.</p>
              <p class=""><strong>No more checking for payments.</strong></p>
              <img style="max-width:100%;" src="/img/bank-integration.jpg" alt="stripe" />
                <v-btn  class="v-btn--medium" depressed small color="accent" @click='goToBilling' >Upgrade my account</v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div class="white py-4" v-if="!showAccounts && hasProAccess" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly, 'misty' : loadingOnAddItem}">
          <v-layout row wrap pb-3>
            <v-flex xs12>
              <span class="subheading">Connect to your Bank</span>
              <p >Click the button below to connect your bank accounts to Worktabs and we will alert you when an invoice is paid automatically.</p>
              <plaid-link
              v-if="showLink"
                  :token='link_token'
                  :env='plaid_env'
                  v-bind="{ onSuccess }">
                  <template slot="button" slot-scope="props">
                      <v-btn class="v-btn--medium" depressed small color="accent"  @click.native="props.onClick">Connect my Bank</v-btn>
                  </template>
              </plaid-link>
              <v-progress-circular
              v-else
              indeterminate
              class="primary--text"
              :width="3"
              :size="35"></v-progress-circular>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="showAccounts">
          <bank-item :item="item" v-for="item in items" :key="item.id"></bank-item>
           <plaid-link
              v-if="showLink"
              class="right block"
              :env='plaid_env'
              :token='link_token'
              v-bind="{ onSuccess }">
              <template slot="button" slot-scope="props">
                <v-btn class="v-btn--medium" depressed small color="accent"  @click.native="props.onClick">Add another Bank</v-btn>
              </template>
            </plaid-link>
        </div>
        <div class="white misty mt-4" :class="{'misty' : loadingOnAddItem}" v-if="loadingOnAddItem">
          <v-layout row wrap  align-center style="cursor:pointer;"   class="py-4 mb-4"  :class="{'pl-4 pr-3' : $vuetify.breakpoint.xsOnly, 'pl-5 pr-2' : !$vuetify.breakpoint.xsOnly}">
            <v-flex xs12 class="text-xs-center">
              <v-progress-circular
                indeterminate
                class="primary--text"
                :width="10"
                :size="70"></v-progress-circular>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

import PlaidLink from 'vue-plaid-link'
import BankItem from '@/components/Shared/BankItem'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/functions'

export default {
  name: 'BankIntegration',
  components: {
    PlaidLink,
    BankItem
  },
  data () {
    return {
      user: this.$store.getters.user,
      site_uri: process.env.VUE_APP_SITEURI,
      plaid_env: process.env.VUE_APP_PLAID_ENV,
      group: this.$store.getters.group,
      items: [],
      link_token: '',
      loadingOnAddItem: '',
      plaid: null
    }
  },
  computed: {
    showAccounts () {
      return this.items.length
    },
    showLink () {
      return this.link_token !== ''
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    hasProAccess () {
      return this.$store.getters.hasProAccess
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    goToBilling () {
      this.onDismissed()
      this.$router.push({ name: 'Billing' })
    },
    async onSuccess (token, metadata) {
      // start loader
      this.loadingOnAddItem = true
      // get the users selected accounts array (array of objects)
      const selectedAccounts = metadata.accounts
      // mpa this to a flat array of ids, we'll filter the full accounts object with this server-side
      const selectedAccountIds = selectedAccounts.map(x => x.id)
      // get the institution ID so we can check for an existing connection, we dont want to allow duplicate connections
      const plaidInstitutionId = metadata.institution.institution_id
      // firebase function to create new Plaid Item
      const registerNewItem = firebase.functions().httpsCallable('registerNewItem')
      try {
        // do the call
        const newItem = await registerNewItem({
          public_token: token,
          groupId: this.user.group,
          selectedAccountIds: selectedAccountIds,
          plaidInstitutionId
        })
        this.loadingOnAddItem = false
        this.$store.dispatch('addNotification', { text: `${metadata.institution.name} added.`, type: 'primary' })
        return newItem
      } catch (error) {
        this.$store.commit('setError', error)
        this.loadingOnAddItem = false
      }
    },
    async loadItems () {
      this.$store.commit('setLoading', true)
      firebase.database().ref(`bank-accounts/${this.user.group}/`).on('value', (data) => {
        const items = []
        const obj = data.val()
        for (let key in obj) {
          items.push(obj[key])
        }
        this.items = items
        this.$store.commit('setLoading', false)
      }, error => {
        console.error(error)
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
      })
    },
    async getLinkToken (groupId) {
      this.$store.commit('setLoading', true)
      try {
        const createLinkToken = await firebase.functions().httpsCallable('createLinkToken')
        const linkTokenResponse = await createLinkToken({
          groupId: this.user.group
        })
        this.$store.commit('setLoading', false)
        if (linkTokenResponse.data.error) {
          this.$store.commit('setError', linkTokenResponse.data.error)
          this.$store.commit('setLoading', false)
        } else {
          this.link_token = linkTokenResponse.data.link_token
          localStorage.setItem('link_token', this.link_token)
        }
      } catch (error) {
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
      }
    },
    async reInitialiseLink () {
      // this is used to reinitialise after oAuth
      // self to this so we can use it in the scope of the success callback
      let self = this
      var linkToken = localStorage.getItem('link_token')
      var handler = this.plaid.create({
        token: linkToken,
        receivedRedirectUri: window.location.href,
        onSuccess: function (publicToken, metadata) {
          self.onSuccess(publicToken, metadata)
        }
      })
      handler.open()
    }
  },
  async created () {
    this.loadItems()
    // only get a link token if you have access
    if (this.hasProAccess) {
      await this.getLinkToken(this.user.group)
    }
  },
  mounted () {
    // messy - consider dropping the vue-plaid-link which also uses this script or revisiting it to see if they cater for oauth yet. 26/1/2022
    // lets add in the plaid link script for use in reinitialising
    let linkScript = document.createElement('script')
    linkScript.async = true
    linkScript.setAttribute('src', 'https://cdn.plaid.com/link/v2/stable/link-initialize.js')
    document.head.appendChild(linkScript)
    linkScript.onload = () => {
      // put the plaid object from the window object
      this.plaid = window.Plaid
      // if we're coming back from Plaid oAuth then we need to reinitialise the link
      if (this.$route.query.oauth_state_id !== '') {
        this.reInitialiseLink()
      }
    }
  }
}
</script>
<style lang="scss" >
  .misty{
    opacity:.3;
  }
</style>
